module.exports = __webpack_public_path__ + "static/media/Dakota.9c703281.jpg";